/* VORLICH social proof widget — generated by scripts/bundle.mjs. Do not edit directly. */
(function(){
'use strict';
var SP_LOCALES={"en":{"someone":"Someone","in":"in","purchased":"purchased","bought_this":"bought this product","just_now":"just now","minutes_ago":"{n} minutes ago","one_minute_ago":"1 minute ago","hours_ago":"{n} hours ago","one_hour_ago":"1 hour ago","recently":"recently","verified":"Verified purchase","close":"Dismiss notification","demo":"Demo data","template":"{who} in {city}, {country} purchased {product} {time}.","template_recent":"{who} in {city}, {country} recently purchased {product}."},"fr":{"someone":"Une personne","in":"à","purchased":"a acheté","bought_this":"a acheté ce produit","just_now":"à l'instant","minutes_ago":"il y a {n} minutes","one_minute_ago":"il y a 1 minute","hours_ago":"il y a {n} heures","one_hour_ago":"il y a 1 heure","recently":"récemment","verified":"Achat vérifié","close":"Fermer la notification","demo":"Données de démonstration","template":"{who} à {city}, {country}, a acheté {product} {time}.","template_recent":"{who} à {city}, {country}, a récemment acheté {product}."},"de":{"someone":"Jemand","in":"aus","purchased":"hat gekauft","bought_this":"hat dieses Produkt gekauft","just_now":"gerade eben","minutes_ago":"vor {n} Minuten","one_minute_ago":"vor 1 Minute","hours_ago":"vor {n} Stunden","one_hour_ago":"vor 1 Stunde","recently":"kürzlich","verified":"Verifizierter Kauf","close":"Benachrichtigung schließen","demo":"Demo-Daten","template":"{who} aus {city}, {country}, hat {time} {product} gekauft.","template_recent":"{who} aus {city}, {country}, hat kürzlich {product} gekauft."},"es":{"someone":"Alguien","in":"de","purchased":"compró","bought_this":"compró este producto","just_now":"justo ahora","minutes_ago":"hace {n} minutos","one_minute_ago":"hace 1 minuto","hours_ago":"hace {n} horas","one_hour_ago":"hace 1 hora","recently":"recientemente","verified":"Compra verificada","close":"Cerrar la notificación","demo":"Datos de demostración","template":"{who} de {city}, {country}, compró {product} {time}.","template_recent":"{who} de {city}, {country}, compró {product} recientemente."},"it":{"someone":"Qualcuno","in":"a","purchased":"ha acquistato","bought_this":"ha acquistato questo prodotto","just_now":"proprio ora","minutes_ago":"{n} minuti fa","one_minute_ago":"1 minuto fa","hours_ago":"{n} ore fa","one_hour_ago":"1 ora fa","recently":"di recente","verified":"Acquisto verificato","close":"Chiudi la notifica","demo":"Dati dimostrativi","template":"{who} a {city}, {country} ha acquistato {product} {time}.","template_recent":"{who} a {city}, {country} ha acquistato {product} di recente."}};
var SP_SAMPLES=[{"k":"demo-1","t":"SUMMIT","h":"summit-medal-hanger","u":"/products/summit-medal-hanger","img":null,"fn":null,"city":"Manchester","cc":"GB","mins":12,"lang":"en"},{"k":"demo-2","t":"Vorlich Running Gift Box","h":"running-gift-box","u":"/products/running-gift-box","img":null,"fn":null,"city":"Sydney","cc":"AU","mins":47,"lang":"en"},{"k":"demo-3","t":"CAIRN Hi-Vis Swim Buoy Tow Float","h":"cairn-open-water-swim-buoy","u":"/products/cairn-open-water-swim-buoy","img":null,"fn":null,"city":"Berlin","cc":"DE","mins":125,"lang":"de"},{"k":"demo-4","t":"SUMMIT Double","h":"summit-double-medal-hanger","u":"/products/summit-double-medal-hanger","img":null,"fn":null,"city":"Austin","cc":"US","mins":1600,"lang":"en"},{"k":"demo-5","t":"SUMMIT Display Sheets","h":"summit-display-sheets","u":"/products/summit-display-sheets","img":null,"fn":null,"city":"Lyon","cc":"FR","mins":30,"lang":"fr"}];
/**
 * Notification string builder (AC-6). Locale-native country names come from
 * Intl.DisplayNames — never English names inside translated strings.
 */
const SUPPORTED_LOCALES = ['en', 'fr', 'de', 'es', 'it'];

function resolveLocale(candidate, override) {
  const pick = (v) => {
    const two = String(v ?? '').slice(0, 2).toLowerCase();
    return SUPPORTED_LOCALES.includes(two) ? two : null;
  };
  return pick(override) ?? pick(candidate) ?? 'en';
}

function countryName(code, locale) {
  const cc = String(code).toUpperCase();
  try {
    const dn = new Intl.DisplayNames([locale], { type: 'region' });
    const name = dn.of(cc);
    // Unassigned codes come back as the code itself or an "unknown region" label — fall back to the code.
    if (!name || name === cc || /unknown|inconnue|unbekannt|desconocid|sconosciut/i.test(name)) return cc;
    return name;
  } catch {
    return cc;
  }
}

function relativeTime(mins, strings) {
  if (mins < 2) return strings.just_now;
  if (mins < 60) return strings.minutes_ago.replace('{n}', String(mins));
  const h = Math.floor(mins / 60);
  if (h === 1) return strings.one_hour_ago;
  if (h < 24) return strings.hours_ago.replace('{n}', String(h));
  return null; // beyond a day → the "recently" template takes over
}

/**
 * Build the visible sentence for one event.
 * event: { t product title, fn first name|null, city, cc country code, mins }
 */
function buildMessage(event, locale, locales) {
  const s = locales[locale] ?? locales.en;
  const who = event.fn ? event.fn : s.someone;
  const country = countryName(event.cc, locale);
  const time = relativeTime(event.mins, s);
  const tpl = time === null ? s.template_recent : s.template;
  return tpl
    .replace('{who}', who)
    .replace('{city}', event.city)
    .replace('{country}', country)
    .replace('{product}', event.t)
    .replace('{time}', time ?? '');
}

/**
 * Timing + selection state machine (AC-5, AC-8) — pure, clock-injected, DOM-free.
 * The DOM layer calls tick() and obeys the returned action.
 */

function createEngine(config, events, opts = {}) {
  return {
    cfg: {
      firstDelay: num(config.first_delay_ms, 6000),
      displayMs: num(config.display_ms, 5000),
      gapMin: num(config.gap_min_ms, 15000),
      gapMax: num(config.gap_max_ms, 25000),
      sessionMax: num(config.session_max, 5),
    },
    queue: [...events],
    shownKeys: new Set(opts.alreadyShown ?? []),
    shownCount: 0,
    phase: 'waiting-first',          // waiting-first | showing | waiting-gap | done
    phaseUntil: (opts.now ?? 0) + num(config.first_delay_ms, 6000),
    current: null,
    rng: opts.rng ?? Math.random,
  };
}

const num = (v, d) => (Number.isFinite(Number(v)) ? Number(v) : d);

/** Advance the machine. Returns {action:'none'|'show'|'hide', event?} */
function tick(m, now, { paused = false } = {}) {
  if (m.phase === 'done') return { action: 'none' };
  const dt = m.lastNow == null ? 0 : Math.max(0, now - m.lastNow);
  m.lastNow = now;
  if (paused) {
    // freeze: paused time (hidden tab / typing) never counts toward any deadline (AC-5)
    m.phaseUntil += dt;
    return { action: 'none' };
  }
  if (now < m.phaseUntil) return { action: 'none' };

  if (m.phase === 'showing') {
    m.phase = 'waiting-gap';
    m.phaseUntil = now + m.cfg.gapMin + Math.floor(m.rng() * (m.cfg.gapMax - m.cfg.gapMin));
    const ev = m.current;
    m.current = null;
    return { action: 'hide', event: ev };
  }

  // waiting-first or waiting-gap → try to show the next unseen event
  if (m.shownCount >= m.cfg.sessionMax) { m.phase = 'done'; return { action: 'none' }; }
  const next = m.queue.find((e) => !m.shownKeys.has(e.k));
  if (!next) { m.phase = 'done'; return { action: 'none' }; }

  m.shownKeys.add(next.k);
  m.shownCount++;
  m.current = next;
  m.phase = 'showing';
  m.phaseUntil = now + m.cfg.displayMs;
  return { action: 'show', event: next };
}

/** Manual dismissal: stop the session (AC-5). */
function dismiss(m) {
  m.phase = 'done';
  m.current = null;
}

/**
 * Source selection (AC-8): demo events ONLY in test mode; real mode with no
 * events shows nothing (fallback text handled separately by the DOM layer).
 */
function selectSource({ testMode, realEvents, sampleEvents }) {
  if (testMode) return { events: sampleEvents, demo: true };
  return { events: realEvents ?? [], demo: false };
}

/** Deterministic A/B assignment from weighted variants (AC-10). */
function assignVariant(sessionId, variants) {
  const entries = Object.entries(variants ?? {}).filter(([, w]) => Number(w) > 0);
  if (!entries.length) return 'control';
  let hash = 5381;
  for (const ch of String(sessionId)) hash = ((hash * 33) ^ ch.charCodeAt(0)) >>> 0;
  const total = entries.reduce((a, [, w]) => a + Number(w), 0);
  let point = hash % total;
  for (const [name, w] of entries) {
    point -= Number(w);
    if (point < 0) return name;
  }
  return entries[0][0];
}

/* VORLICH social proof — DOM layer (AC-4, AC-5, AC-7, AC-8, AC-10).
   Concatenated after the lib modules by scripts/bundle.mjs into an IIFE.
   Expects globals from earlier segments: resolveLocale, buildMessage, createEngine,
   tick, dismiss, selectSource, assignVariant, SP_LOCALES (inlined), SP_SAMPLES (inlined). */

(function boot() {
  var CTX = window.__VORLICH_SP__;
  if (!CTX || !CTX.endpoint) return;
  if (window.__vspBooted) return; window.__vspBooted = true;

  var doc = document;
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = matchMedia('(max-width: 768px)').matches;

  // ---- session state -------------------------------------------------------
  function store(kind) { try { return kind === 'l' ? localStorage : sessionStorage; } catch (e) { return null; } }
  function sget(k, kind) { var s = store(kind); return s ? s.getItem(k) : null; }
  function sset(k, v, kind) { var s = store(kind); if (s) try { s.setItem(k, v); } catch (e) {} }

  var sid = sget('vsp:sid');
  if (!sid) { sid = Math.random().toString(36).slice(2, 12); sset('vsp:sid', sid); }

  var dismissedUntil = Number(sget('vsp:dismissed', 'l') || 0);
  if (sget('vsp:dismissed-session') === '1' || Date.now() < dismissedUntil) return;

  // ---- fetch (cached per session, 5 min) ----------------------------------
  var cacheRaw = sget('vsp:feed');
  var cached = null;
  if (cacheRaw) { try { cached = JSON.parse(cacheRaw); } catch (e) {} }

  function start(payload) {
    if (!payload || payload.enabled !== true) return;
    var cfg = payload.cfg || {};
    if (mobile ? cfg.mobile === false : cfg.desktop === false) return;
    var path = location.pathname;
    var excluded = (cfg.excluded_urls || []).some(function (u) { return u && path.indexOf(u) === 0; });
    if (excluded || /\/(checkout|cart)\b/.test(path)) return;

    var source = selectSource({
      testMode: cfg.test_mode === true,
      realEvents: payload.events,
      sampleEvents: SP_SAMPLES,
    });
    var locale = resolveLocale(CTX.locale || doc.documentElement.lang, cfg.language_override);
    var variant = assignVariant(sid, cfg.ab_variants);

    // variant hooks (AC-10): named variants may flip presentation settings
    if (variant === 'right') cfg.position = 'bottom-right';
    if (variant === 'no_image') cfg.show_image = false;

    if (!source.events.length) {
      if (cfg.fallback_enabled === true && cfg.fallback_message) {
        renderCard({ text: String(cfg.fallback_message), fallback: true });
      }
      return;
    }
    runEngine(cfg, source, locale, variant);
  }

  function runEngine(cfg, source, locale, variant) {
    var seen = [];
    try { seen = JSON.parse(sget('vsp:seen') || '[]'); } catch (e) {}
    var m = createEngine(cfg, source.events, { now: performance.now(), alreadyShown: seen });
    var typing = false;
    doc.addEventListener('focusin', function (e) { typing = /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName); });
    doc.addEventListener('focusout', function () { typing = false; });

    var iv = setInterval(function () {
      var a = tick(m, performance.now(), { paused: doc.hidden || typing });
      if (a.action === 'show') {
        sset('vsp:seen', JSON.stringify(Array.from(m.shownKeys)));
        showEvent(a.event, cfg, locale, variant, source.demo, function onDismiss() {
          dismiss(m);
          sset('vsp:dismissed-session', '1');
          var days = Number(cfg.dismiss_days) === 30 ? 30 : 7;
          sset('vsp:dismissed', String(Date.now() + days * 864e5), 'l');
          clearInterval(iv);
        });
      } else if (a.action === 'hide') {
        hideCard();
      } else if (m.phase === 'done' && !m.current) {
        clearInterval(iv);
      }
    }, 250);
  }

  // ---- rendering -----------------------------------------------------------
  var root, card;
  function ensureRoot(position, animation) {
    if (root) return;
    root = doc.createElement('div');
    root.id = 'vsp-root';
    root.setAttribute('data-pos', position === 'bottom-right' ? 'right' : 'left');
    var css =
      '#vsp-root{position:fixed;bottom:16px;z-index:2147483000;max-width:min(360px,calc(100vw - 24px));font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif}' +
      '#vsp-root[data-pos=left]{left:12px}#vsp-root[data-pos=right]{right:12px}' +
      '@media(max-width:768px){#vsp-root{bottom:76px}}' + // clears mobile nav / sticky ATC / cookie bar
      '.vsp-card{display:flex;align-items:center;gap:12px;background:#0A0A0A;color:#EFEFEA;border:1px solid #26261F;border-left:2px solid #FC712B;padding:12px 14px;box-shadow:0 8px 28px rgba(0,0,0,.5);cursor:pointer;text-decoration:none;opacity:0;transform:translateY(12px);transition:opacity .3s ease,transform .3s ease}' +
      '.vsp-card.vsp-in{opacity:1;transform:translateY(0)}' +
      '.vsp-noanim .vsp-card{transition:none;transform:none}' +
      '.vsp-img{width:44px;height:44px;object-fit:cover;flex:0 0 44px;background:#141414}' +
      '.vsp-body{min-width:0;font-size:13px;line-height:1.45;color:#EFEFEA}' +
      '.vsp-meta{display:flex;align-items:center;gap:6px;margin-top:4px;font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;color:#8A8A84}' +
      '.vsp-meta svg{width:11px;height:11px;fill:#FC712B;flex:none}' +
      '.vsp-demo{color:#FC712B;border:1px solid #FC712B;padding:0 4px;border-radius:2px}' +
      '.vsp-x{flex:none;background:none;border:0;color:#8A8A84;font-size:16px;line-height:1;padding:6px;cursor:pointer;align-self:flex-start;margin:-4px -6px 0 0}' +
      '.vsp-x:hover,.vsp-x:focus-visible{color:#EFEFEA}' +
      '.vsp-card:focus-visible,.vsp-x:focus-visible{outline:2px solid #FC712B;outline-offset:2px}';
    var style = doc.createElement('style');
    style.textContent = css;
    root.appendChild(style);
    if (reduceMotion || animation === 'none') root.className = 'vsp-noanim';
    doc.body.appendChild(root);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var VERIFIED = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 0l2 1.6 2.5-.3 1 2.3 2.3 1-.3 2.5L17 8l-1.5 1.9.3 2.5-2.3 1-1 2.3-2.5-.3L8 16l-2-1.6-2.5.3-1-2.3-2.3-1 .3-2.5L-1 8l1.5-1.9L.2 3.6l2.3-1 1-2.3 2.5.3z" transform="translate(0.5)"/><path d="M7 10.8L4.6 8.4l1-1 1.4 1.4 3.4-3.4 1 1z" fill="#0A0A0A"/></svg>';

  function trackBeacon(type, eventKey, extra) {
    if (!CTX.track) return;
    var consent = window.Shopify && window.Shopify.customerPrivacy;
    var allowed = false;
    try { allowed = !!(consent && consent.analyticsProcessingAllowed && consent.analyticsProcessingAllowed()); } catch (e) {}
    if (!allowed) return; // default to no-track when consent state is unknown (AC-10)
    var body = JSON.stringify(Object.assign({
      type: type, event_key: eventKey || null, session_hash: sid,
      device: mobile ? 'mobile' : 'desktop',
      page_type: CTX.pageType, country_code: CTX.country || null, locale: CTX.locale || null,
    }, extra || {}));
    try { navigator.sendBeacon(CTX.track, new Blob([body], { type: 'application/json' })); } catch (e) {}
  }

  var currentDismiss = null;
  function showEvent(e, cfg, locale, variant, demo, onDismiss) {
    ensureRoot(cfg.position, cfg.animation);
    hideCard(true);
    var msg = buildMessage(e, locale, SP_LOCALES);
    var s = SP_LOCALES[locale] || SP_LOCALES.en;
    var href = e.u + (location.search.indexOf('utm_') > -1 ? location.search : '');

    card = doc.createElement('a');
    card.className = 'vsp-card';
    card.href = href;
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    card.innerHTML =
      (cfg.show_image !== false && e.img ? '<img class="vsp-img" alt="" loading="lazy" src="' + esc(e.img) + '">' : '') +
      '<span class="vsp-body">' + esc(msg) +
      '<span class="vsp-meta">' + VERIFIED + '<span>' + esc(s.verified) + '</span>' +
      (demo ? '<span class="vsp-demo">' + esc(s.demo) + '</span>' : '') +
      '</span></span>' +
      '<button type="button" class="vsp-x" aria-label="' + esc(s.close) + '">&times;</button>';

    card.addEventListener('click', function (ev) {
      if (ev.target.closest('.vsp-x')) { ev.preventDefault(); ev.stopPropagation(); currentDismiss && currentDismiss(); hideCard(); return; }
      trackBeacon('click', e.k, { variant: variant });
    });
    doc.addEventListener('keydown', escHandler);
    currentDismiss = onDismiss;

    root.appendChild(card);
    requestAnimationFrame(function () { requestAnimationFrame(function () { card && card.classList.add('vsp-in'); }); });
    trackBeacon('impression', e.k, { variant: variant });
  }

  function escHandler(ev) { if (ev.key === 'Escape' && card) { currentDismiss && currentDismiss(); hideCard(); } }

  function hideCard(instant) {
    if (!card) return;
    var el = card; card = null;
    doc.removeEventListener('keydown', escHandler);
    if (instant || reduceMotion) { el.remove(); return; }
    el.classList.remove('vsp-in');
    setTimeout(function () { el.remove(); }, 320);
  }

  function renderCard(opts) { // aggregate fallback (AC-8) — non-interactive, no analytics
    ensureRoot('bottom-left', 'slide');
    var el = doc.createElement('div');
    el.className = 'vsp-card';
    el.setAttribute('role', 'status');
    el.style.cursor = 'default';
    el.innerHTML = '<span class="vsp-body">' + esc(opts.text) + '</span>';
    root.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('vsp-in'); });
    setTimeout(function () { el.classList.remove('vsp-in'); setTimeout(function () { el.remove(); }, 320); }, 6000);
  }

  // ---- kick off ------------------------------------------------------------
  if (cached && Date.now() - cached.at < 300000) { start(cached.payload); return; }
  var qs = '?country=' + encodeURIComponent(CTX.country || '') +
    '&page=' + encodeURIComponent(CTX.pageType || 'home') +
    (CTX.product ? '&product=' + encodeURIComponent(CTX.product) : '') +
    (CTX.collections ? '&collections=' + encodeURIComponent(CTX.collections) : '');
  fetch(CTX.endpoint + qs, { credentials: 'omit' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (payload) {
      if (!payload) return;
      sset('vsp:feed', JSON.stringify({ at: Date.now(), payload: payload }));
      start(payload);
    })
    .catch(function () { /* API unavailable → widget stays silent (AC-technical) */ });
})();

})();
